<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div id="section-form-elements" class="container m-t-40">
  <div class="simple-card">
    <p class="h2 p-tb-12 border-bottom m-b-0">Form Elements</p>

    <form class="m-t-20" [formGroup]="form" (submit)="submit()">
      <div class="row">
        <div class="col-12 col-md-4">
          <div class="form-group">
            <countries-dropdown
              [form]="form"
              [isocode]="country?.isocode"
              [countries$]="countries$"
              (_onSelectCountry)="setCountry($event)"
            ></countries-dropdown>

            <cx-form-errors [control]="form.get('country')"></cx-form-errors>
          </div>
        </div>

        <div class="col-12 col-md-4">
          <div class="form-group" *ngIf="titles$ | async as titles">
            <label>
              <span class="label-content">{{ 'register.titleOptional' | cxTranslate }}</span>
              <!-- <ng-select [clearable]="false" [items]="titles$ | async" [placeholder]="'register.selectTitle' | cxTranslate" [searchable]="false" bindLabel="name" bindValue="code" formControlName="titleCode" id="title-select" [cxNgSelectA11y]="{ ariaLabel: 'register.title' | cxTranslate }">
							</ng-select> -->

              <select class="form-control" formControlName="titleCode">
                <option value="" disabled selected>{{ 'generic.selectAnOption' | cxTranslate }}</option>
                <option *ngFor="let item of titles" [attr.aria-label]="item.label" value="{{ item.code }}">
                  {{ item.label }}
                </option>
              </select>

              <cx-form-errors [control]="form.get('titleCode')"></cx-form-errors>
            </label>
          </div>
        </div>

        <div class="col-12 col-md-4">
          <div class="form-group">
            <label>
              <span class="label-content">{{ 'register.firstName.label' | cxTranslate }} </span>

              <input
                class="form-control"
                type="text"
                name="firstname"
                maxlength="10"
                placeholder="{{ 'register.firstName.placeholder' | cxTranslate }}"
                formControlName="firstName"
              />
              <cx-form-errors [control]="form.get('firstName')"></cx-form-errors>
            </label>
          </div>
        </div>

        <div class="col-12 col-md-4">
          <div class="form-group">
            <label>
              <span class="label-content">{{ 'register.emailAddress.label' | cxTranslate }} </span>
              <div class="container-icon">
                <input
                  class="form-control"
                  type="email"
                  name="email"
                  placeholder="{{ 'register.emailAddress.placeholder' | cxTranslate }}"
                  formControlName="email"
                />

                <span class="icon material-symbols-outlined"> mail </span>
              </div>
              <cx-form-errors [control]="form.get('email')"></cx-form-errors>
            </label>
          </div>
        </div>

        <div class="col-12 col-md-4">
          <div class="form-group">
            <label>
              <span class="label-content">{{ 'styleGuide.demoForm.document.title' | cxTranslate }} </span>
              <input
                class="form-control"
                type="text"
                name="document"
                [mask]="'000.000.000-00 || 000.000.000/0000-00'"
                placeholder="{{ 'styleGuide.demoForm.document.placeholder' | cxTranslate }}"
                formControlName="document"
              />
              <cx-form-errors [control]="form.get('document')"></cx-form-errors>
            </label>
          </div>
        </div>

        <div class="col-12 col-md-4">
          <div class="form-group">
            <label>
              <span class="label-content">{{ 'styleGuide.demoForm.phone.title' | cxTranslate }} </span>

              <div class="container-phone">
                <span class="phone-code">
                  {{ country?.diallingCode || 00 }}
                </span>

                <input
                  class="form-control"
                  type="text"
                  name="phone"
                  [mask]="country?.phoneMask || ''"
                  (keypress)="validateInput($event)"
                  placeholder="{{ 'styleGuide.demoForm.phone.placeholder' | cxTranslate }}"
                  formControlName="phone"
                />
              </div>

              <cx-form-errors [control]="form.get('phone')"></cx-form-errors>
            </label>
          </div>
        </div>

        <div class="col-12 col-md-4">
          <div class="form-group">
            <label>
              <span class="label-content">{{ 'register.password.label' | cxTranslate }} </span>

              <div class="container-icon">
                <input
                  #pw
                  class="form-control"
                  type="password"
                  name="password"
                  placeholder="{{ 'register.password.placeholder' | cxTranslate }}"
                  formControlName="password"
                />

                <btn-visibility (statusChange)="setInputType($event, pw)"></btn-visibility>
              </div>

              <cx-form-errors [control]="form.get('password')"></cx-form-errors>
            </label>
          </div>
        </div>

        <div class="col-12 col-md-4">
          <div class="form-group">
            <label>
              <span class="label-content">{{ 'register.confirmPassword.label' | cxTranslate }} </span>

              <div class="container-icon">
                <input
                  #pwConfirm
                  class="form-control"
                  type="password"
                  name="confirmPassword"
                  placeholder="{{ 'register.confirmPassword.placeholder' | cxTranslate }}"
                  formControlName="passwordconf"
                />

                <btn-visibility (statusChange)="setInputType($event, pwConfirm)"></btn-visibility>
              </div>

              <cx-form-errors [control]="form.get('passwordconf')"></cx-form-errors>
            </label>
          </div>
        </div>

        <div class="col-12" *ngIf="subscriptiontype$ | async as subscriptiontype">
          <div class="form-group">
            <label>
              <span class="label-content">{{ 'styleGuide.demoForm.subscriptiontypes.title' | cxTranslate }}</span>
              <div class="form-check" *ngFor="let type of subscriptiontype">
                <input
                  id="subscriptiontype-{{ type.code }}"
                  class="form-check-input"
                  role="radio"
                  type="radio"
                  aria-checked="true"
                  [value]="type.code"
                  formControlName="subscriptiontype"
                />
                <label class="cx-payment-type-label form-check-label form-radio-label" for="subscriptiontype-{{ type.code }}">
                  <div class="cx-payment-type">
                    {{ 'styleGuide.demoForm.subscriptiontypes.subscriptiontype_' + type?.code | cxTranslate }}
                  </div>
                </label>
              </div>
              <cx-form-errors [control]="form.get('subscriptiontype')"></cx-form-errors>
            </label>
          </div>
        </div>

        <div class="col-12">
          <div class="form-group">
            <label>
              <span class="label-content">{{ 'styleGuide.demoForm.comment.title' | cxTranslate }}</span>
              <textarea
                class="form-control"
                [maxLength]="255"
                rows="3"
                name="comment"
                formControlName="comment"
                [placeholder]="'styleGuide.demoForm.comment.placeholder' | cxTranslate"
              ></textarea>
              <cx-form-errors [control]="form.get('comment')"></cx-form-errors>
            </label>
          </div>
        </div>

        <div class="col-12">
          <div class="form-group">
            <div class="form-check">
              <label>
                <input type="checkbox" name="termsandconditions" formControlName="termsandconditions" />
                <span class="form-check-label">
                  {{ 'register.confirmThatRead' | cxTranslate }}

                  <a [routerLink]="{ cxRoute: 'termsAndConditions' } | cxUrl" target="_blank" rel="noopener noreferrer">
                    {{ 'register.termsAndConditions' | cxTranslate }} </a
                  >*
                </span>
              </label>
            </div>

            <cx-form-errors [control]="form.get('termsandconditions')"></cx-form-errors>
          </div>
        </div>
      </div>

      <div class="row justify-content-end m-t-20">
        <div class="col-12 col-md-4 col-lg-3">
          <button type="submit" class="btn btn-primary w-100">{{ 'generic.submit' | cxTranslate }}</button>
        </div>
      </div>
    </form>
  </div>
</div>
